import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from '../../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { TareaPodaModel } from '../../../../../../models/tareas/tarea-poda.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export class TareasMtoPodaFormDefinition extends MtoReactiveFormDefinition<TareaPodaModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaPodaModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'poda',
            header: 'Datos de podas',
            database: 'tareas_mto_poda',
            signatureFolder: 'poda',
            sections: this.getSections(),
        });
    }

    private getSections(): MtoSectionSpec<TareaPodaModel>[] {
        return [
            { name: 'Datos de podas', fields: [...this.getDefaultMainFieldSpecs()] },
            { name: 'Datos de poda', fields: [
                this.field('cipreses', `Cipreses`, InputType.SWITCH, { width: 3 }),
                this.field('rosales', `Rosales`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Arbolado', fields: [
                this.field('arbolado_olivos', `Olivos`, InputType.SWITCH, { width: 3 }),
                this.field('arbolado_pinos', `Pinos`, InputType.SWITCH, { width: 3 }),
                this.field('arbolado_otros', `Otros`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Vallas', fields: [
                this.field('valla_hiedra', `Hiedra`, InputType.SWITCH, { width: 3 }),
                this.field('valla_bouganvilla', `Bouganvilla`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Palmeras', fields: [
                this.field('palmeras_canadiensis', `Canadiensis`, InputType.SWITCH, { width: 3 }),
                this.field('palmeras_washingtonias', `Washingtonias`, InputType.SWITCH, { width: 3 }),
                this.field('palmeras_dactyliferas', `Dactyliferas`, InputType.SWITCH, { width: 3 }),
                this.field('palmeras_arecastrum', `Arecastrum`, InputType.SWITCH, { width: 3 }),
                this.field('palmeras_chapaerop', `Chamaerop`, InputType.SWITCH, { width: 3 }),
                this.field('palmeras_cicas', `Cicas`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Acuchillado Tronco', fields: [
                this.field('acuchillado_canadiensis', `Canadiensis`, InputType.SWITCH, { width: 3 }),
                this.field('acuchillado_washingtonias', `Washingtonias`, InputType.SWITCH, { width: 3 }),
                this.field('acuchillado_dactyliferas', `Dactyliferas`, InputType.SWITCH, { width: 3 }),
                this.field('acuchillado_arecastrum', `Arecastrum`, InputType.SWITCH, { width: 3 }),
                this.field('acuchillado_chapaerop', `Chamaerop`, InputType.SWITCH, { width: 3 }),
                this.field('acuchillado_cicas', `Cicas`, InputType.SWITCH, { width: 3 }),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
